import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { addServiceToCart, updateServicesToCart } from '../../../../store/actions/cartAction';
import { receiveError } from '../../../../store/actions/notificationAction';

import Button from '@material-ui/core/Button';
import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';

import CommonAdditionalService from '../commonAdditionalService/CommonAdditionalService';
import BreakdownByHouseBill from '../breakdownByHouseBill/BreakdownByHouseBill';
import StorageContainer from '../storage/StorageContainer';
import PerishableStorageContainer from '../perishableStorage/PerishableStorageContainer';
import OtherAdditionalService from '../otherAdditionalService/OtherAdditionalService';
import AdjustService from '../adjustService/adjustService';

import FeeParams from '../../../../models/FeeParams';
import CartItem from '../../../../models/CartItem';
import CartService from '../../../../models/CartService';
import AddServicesUnits from '../../../../models/AddServicesUnits';
import CartServiceServerParams from '../../../../models/CartServiceServerParams';
import ResponseError from '../../../../models/ResponseError';

import { debounce } from '../../../../utils/debounce'; 

import additionalServiceWrapperContainerStyles from './additionalServiceWrapperContainer.module.css';
import { findCartItemService } from '../../../../utils/cartService';
import AddServicesTariff from '../../../../models/AddServicesTariff';
import CustomsFeeContainer from '../customsFee/CustomsFeeContainer';

const DEBOUNCE_TIME_MS: number = 1200;

interface AdditionalServiceWrapperContainerProps {
  serviceRawName: string;
  serviceDetails: AddServicesUnits;
  total: number;
  getFeeRequest: Function;
  addServiceToCart: Function;
  updateServicesToCart: Function;
  receiveError: Function;
  cartItem: CartItem;
  additionalServiceTariff: AddServicesTariff;
  isDeletedService: boolean;
  changeIsDeleteStatus: Function;
  allowedService: boolean;
  isServiceInCart: boolean;
  isExport?: boolean;
};

interface AdditionalServiceWrapperContainerState {
  error: boolean;
  payByHouseBillBreakByError: boolean;
  optionalParams: FeeParams;
  breakByHouseBillValue: number;
  additionalInformation: string;
  additionalInformationBreakBy: string;
  doAdd: boolean;
  inputValue: string;
  newTotal: number;
  otherServiceReason: string;
  adjustServiceReason: string;
  otherServiceTotal: string;
  adjustServiceTotal: string;
  showedPayPerHawbWithBreakdown: boolean;
  transactionDate: string;
};

class AdditionalServiceWrapperContainer extends Component<AdditionalServiceWrapperContainerProps, AdditionalServiceWrapperContainerState> {

  state = {
    error: false,
    payByHouseBillBreakByError: false,
    optionalParams: {},
    breakByHouseBillValue: 0,
    additionalInformation: '',
    additionalInformationBreakBy: '',
    doAdd: true,
    inputValue: '',
    newTotal: 0,
    otherServiceReason: '',
    adjustServiceReason: '',
    otherServiceTotal: '',
    adjustServiceTotal: '',
    showedPayPerHawbWithBreakdown: false,
    transactionDate: moment().format('YYYYMMDD')
  };

  componentDidMount() {
    this.setServiceUnitValueTotalInfo();
    this.updateShowedPayPerHawbWithBreakdown();
  }

  componentDidUpdate(prevProps: AdditionalServiceWrapperContainerProps) {

    if (prevProps.serviceRawName !== this.props.serviceRawName) {
      this.setServiceUnitValueTotalInfo();
      this.updateShowedPayPerHawbWithBreakdown();
    }

    if (prevProps.total !== this.props.total) {
      this.setState({ newTotal: this.props.total });
    }

    if (prevProps.isDeletedService !== this.props.isDeletedService) {
      this.setState({ doAdd: this.props.isDeletedService });
    }
  }

  updateShowedPayPerHawbWithBreakdown = () => {
    
    if(this.props.serviceRawName === 'breakdown_hawb') {
      if(!findCartItemService(this.props.cartItem, 'breakdown_hawb')) {
        this.setState({showedPayPerHawbWithBreakdown: true});
      } else {
        this.setState({showedPayPerHawbWithBreakdown: false});
      }
    }
  }

  checkIsNumber = (input: string): void => {

    if (input.trim().length > 0) {

      const numberRegex: RegExp = new RegExp(/^[0-9]+$/);
      let hasError: boolean = !numberRegex.test(input);
      if(!hasError && Number(input) <= 0)
        hasError = true;
  
      this.setState({ newTotal: 0, error: hasError });
  
      if (!hasError) {

        this.calculateHouseBillTotalPerUnit(input);
      } 
    }

    if (input.trim().length === 0) {

      this.setState({ newTotal: 0 });
    }
  }

  calculateHouseBillTotalPerUnit = (stringValue: string): void => {

    const value: number = +stringValue;
    const optionalParams: FeeParams = { };

    switch (this.props.serviceRawName) {

      case 'per_hawb':
      case 'per_hawb_exclude_import_service':
        optionalParams.number_hawb = value;
        break;
      case 'breakdown_hawb':
          optionalParams.kg = this.props.cartItem.weight;
        break;
      case 'reicing':
          optionalParams.kg = value;
        break;
      case 'bup_ld3':
      case 'bup_ld7':
      case 'bup_main_deck':
      case 'skid_exch':
      case 'bup_q7':
      case 'bup_20ft':
      case 'label_freight':
          optionalParams.units = value;
        break;
      default: break;
    }

    this.setState({ newTotal: this.props.total, optionalParams });
    this.props.getFeeRequest(optionalParams);
  }

  setInputValueFromBreakByHouseBill = (value: number): void => {
    this.setState({ breakByHouseBillValue: value });
  }

  handleChange = (event: any, propertyName?: string)  => {

    const value: string = event.target.value;

    switch (propertyName) {
      case 'inputValue': this.setState({ inputValue: value }); break;
      case 'otherServiceTotal': this.setState({ otherServiceTotal: value }); break;
      case 'otherServiceReason': this.setState({ otherServiceReason: value }); break;
      case 'additionalInformation': this.setState({ additionalInformation: value }); break;
      case 'additionalInformationBreakBy': this.setState({ additionalInformationBreakBy: value }); break;
      case 'adjustServiceReason': this.setState({ adjustServiceReason: value}); break;
      case 'adjustServiceTotal': this.setState({ adjustServiceTotal: value}); break;
      default: break;
    };
  };

  getServiceUnitValueTotalInfo(): Array<any> {

    const result: Array<any> = new Array(3);
    const cartService: CartService | undefined = this.props.cartItem.services.find((cartService: CartService) => {
      return cartService.type === this.props.serviceRawName;
    });

    if (cartService) {

      result[1] = cartService.calculations.total;
      result[2] = cartService.additional_info;

      switch (this.props.serviceRawName) {

        case 'per_hawb':
        case 'per_hawb_exclude_import_service':
          result[0] = cartService.params.number_hawb;
          return result;
        case 'reicing':
          result[0] = cartService.params.kg;
          return result;
        case 'bup_ld3':
        case 'bup_ld7':
        case 'bup_main_deck':
        case 'skid_exch':
        case 'bup_q7':
        case 'bup_20ft':
        case 'label_freight':
          result[0] = cartService.params.units;
          return result;
        case 'storage_fee':
          return result;
        case 'perishable_storage':
          return result;
        case 'customs_fee': 
          return result;
        case 'cage_vault':
          return result;
        case 'certified_manifest_charge':
          result[0] = cartService.params.transaction_date;
          return result;
        default:
          result.length = 0;
          return result;
      }
    }

    result.length = 0;
    return result;
  }

  setServiceUnitValueTotalInfo = (): void => {

    const unitValueTotalInfo: Array<any> = this.getServiceUnitValueTotalInfo();
    let value: string = '';
    let add: boolean = true;
    let totalTemp: number = 0;
    let commonAddInfoTemp = '';

    let tsDate: string | undefined = undefined;
    if (unitValueTotalInfo.length > 0) {

      if (unitValueTotalInfo[0] !== undefined) { // In case of storage_fee

        value = unitValueTotalInfo[0].toString();
        totalTemp = unitValueTotalInfo[1];
        
        if (this.props.serviceRawName === 'certified_manifest_charge') {
          tsDate = value;
        }

        this.calculateHouseBillTotalPerUnit(value);
      }

      add = false;
      commonAddInfoTemp = unitValueTotalInfo[2];
    }

    const stateToUpdate: any = {
      inputValue: value,
      newTotal: totalTemp,
      additionalInformation: commonAddInfoTemp,
      error: false,
      doAdd: add
    };

    if (tsDate) {
      stateToUpdate.transactionDate = tsDate;
    }

    this.setState(stateToUpdate);
  }

  checkIsNumberAndRequest = debounce(this.checkIsNumber, DEBOUNCE_TIME_MS);

  renderAdditionalServiceComponent = (serviceRawName: string): JSX.Element | null => {
  console.log('🚀 ~ AdditionalServiceWrapperContainer ~ serviceRawName:', serviceRawName)

    let bupId: string = '';

    if (serviceRawName === 'bup_ld3') {
      bupId = '3';
    }

    if (serviceRawName === 'bup_ld7') {
      bupId = '7';
    }

    if (serviceRawName === 'bup_q7') {
      bupId = 'q7';
    }

    if (serviceRawName === 'bup_20ft') {
      bupId = '20';
    }

    if (serviceRawName === 'label_freight') {
      bupId = 'label';
    }

    if (serviceRawName === 'bup_main_deck') {
      bupId = 'main';
    }

    if (serviceRawName === 'skid_exch') {
      bupId = 'skid';
    }
    
    switch (serviceRawName) {

      case 'per_hawb':
      case 'per_hawb_exclude_import_service':
      case 'reicing': 
      case 'bup_ld3':
      case 'bup_ld7':
      case 'bup_20ft':
      case 'bup_q7':
      case 'label_freight':
      case 'bup_main_deck':
      case 'skid_exch':  
        return <CommonAdditionalService
                  serviceDetails={ this.props.serviceDetails }
                  isNumber={ this.checkIsNumberAndRequest }
                  error={ this.state.error }
                  value={ this.state.inputValue }
                  total={ this.state.newTotal }
                  bupId={ bupId }
                  additionalInformation={ this.state.additionalInformation }
                  handleChange={ this.handleChange }
                  allowedService={ this.props.allowedService }
                  isServiceInCart={ this.props.isServiceInCart }
                />;
      case 'breakdown_hawb':
        return <BreakdownByHouseBill
                  serviceDetails={ this.props.serviceDetails }
                  total={ this.props.total }
                  selectedAwbCode={ this.props.cartItem.code }
                  selectedAwbNumber={ this.props.cartItem.number }
                  selectedAwbVer={ this.props.cartItem.version }
                  getFeeRequest={ this.props.getFeeRequest }
                  handleChange={ this.handleChange }
                  additionalInformation={ this.state.additionalInformation }
                  getBreakByHouseBillInputValue={ this.setInputValueFromBreakByHouseBill }
                  payByHouseBillBreakByError={ this.state.payByHouseBillBreakByError }
                  changeDoAdd={ this.changeDoAdd }
                  allowedService={ this.props.allowedService }
                  isServiceInCart={ this.props.isServiceInCart }
                />;
      case 'storage_fee': return <StorageContainer
                                    serviceDetails={ this.props.serviceDetails }
                                    selectedAwbCode={ this.props.cartItem.code }
                                    selectedAwbNumber={ this.props.cartItem.number }
                                    selectedAwbVer={ this.props.cartItem.version }
                                    handleChange={ this.handleChange }
                                    additionalInformation={ this.state.additionalInformation }
                                  />;
      case 'perishable_storage': return <PerishableStorageContainer
                                    serviceRawName={ serviceRawName } 
                                    serviceDetails={ this.props.serviceDetails }
                                    selectedAwbCode={ this.props.cartItem.code }
                                    selectedAwbNumber={ this.props.cartItem.number }
                                    selectedAwbVer={ this.props.cartItem.version }
                                    handleChange={ this.handleChange }
                                    additionalInformation={ this.state.additionalInformation }
                                    disabled={ !this.props.allowedService && !this.props.isServiceInCart }
                                  />;
      case 'customs_fee': return <CustomsFeeContainer
                                    serviceDetails={ this.props.serviceDetails }
                                    selectedAwbCode={ this.props.cartItem.code }
                                    selectedAwbNumber={ this.props.cartItem.number }
                                    selectedAwbVer={ this.props.cartItem.version }
                                    handleChange={ this.handleChange }
                                    additionalInformation={ this.state.additionalInformation }
                                  />
      case 'cage_vault': return <PerishableStorageContainer
                            serviceRawName={ serviceRawName }
                            serviceDetails={ this.props.serviceDetails }
                            selectedAwbCode={ this.props.cartItem.code }
                            selectedAwbNumber={ this.props.cartItem.number }
                            selectedAwbVer={ this.props.cartItem.version }
                            handleChange={ this.handleChange }
                            additionalInformation={ this.state.additionalInformation }
                            disabled={ !this.props.allowedService && !this.props.isServiceInCart }
                          />;
      case 'other': return <OtherAdditionalService
                              total={ this.state.otherServiceTotal }
                              reason={ this.state.otherServiceReason }
                              handleChange={ this.handleChange }
                              additionalInformation={ this.state.additionalInformation }
                              error={ this.state.error }
                            />;
      case 'gha_adjust': return <AdjustService
                                  total={ this.state.adjustServiceTotal }
                                  reason={ this.state.adjustServiceReason }
                                  handleChange={ this.handleChange }
                                  additionalInformation={ this.state.additionalInformation }
                                  error={ this.state.error }
                                />;
        case 'certified_manifest_charge': return (
          <div style={{ marginTop: '15px', marginBottom: '15px' }}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="MM/DD/YYYY"
              margin="normal"
              id="date-picker-inline"
              label="Transaction Date"
              value={moment(this.state.transactionDate, 'YYYYMMDD')}
              onChange={(date) => this.setState({ transactionDate: date ? date.format('YYYYMMDD') : moment().format('YYYYMMDD'), error: false })}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </div>
        );
      default: return null;
    }
  }

  changeDoAdd = (doAdd: boolean): void => {
    this.setState({ doAdd: doAdd });
  }

  handleAddServiceToCart = (): void => {

    const allServicesAndParams: Array<CartServiceServerParams> = [];
    let params: CartServiceServerParams;

    switch (this.props.serviceRawName) {

      case 'breakdown_hawb':
  
        params = {
          type: this.props.serviceRawName,
          params: {},
          additional_info: this.state.additionalInformationBreakBy
        };
        if(this.state.showedPayPerHawbWithBreakdown) {
          if (this.state.breakByHouseBillValue === 0) {
            this.setState({ payByHouseBillBreakByError: true });
            return;
          }

          let payPerHawbToAdd: string = '';
          if(this.props.additionalServiceTariff.per_hawb) {
            payPerHawbToAdd = 'per_hawb';
          } else if(this.props.additionalServiceTariff.per_hawb_exclude_import_service) {
            payPerHawbToAdd = 'per_hawb_exclude_import_service';
          }
          const payByHouseBillParams: CartServiceServerParams = {
            type: payPerHawbToAdd,
            params: { number_hawb: this.state.breakByHouseBillValue },
            additional_info: this.state.additionalInformation
          };

          allServicesAndParams.push(payByHouseBillParams);
        }
        break;

      case 'storage_fee': 
        params = {
          type: 'storage_fee',
          params: { },
          additional_info: this.state.additionalInformation
        };
        break;
      
      case 'customs_fee': 
        params = {
          type: 'customs_fee',
          params: { },
          additional_info: this.state.additionalInformation
        };
      break;
      
      case 'perishable_storage': 
        params = {
          type: 'perishable_storage',
          params: { },
          additional_info: this.state.additionalInformation
        };
        break;

      case 'cage_vault': 
        params = {
          type: 'cage_vault',
          params: { },
          additional_info: this.state.additionalInformation
        };
        break;

      case 'other': 
        if (!this.state.otherServiceReason || !this.state.otherServiceTotal || isNaN(Number(this.state.otherServiceTotal)) 
            || this.state.otherServiceTotal !== '' && Number(this.state.otherServiceTotal) <= 0) {
          this.setState({ error: true });
          return;
        }

        params = {
          type: 'other',
          params: {
            reason: this.state.otherServiceReason,
            manual_cost_usd: this.state.otherServiceTotal
          },
          additional_info: this.state.additionalInformation
        };
        break;

        case 'gha_adjust':
          if (!this.state.adjustServiceReason || !this.state.adjustServiceTotal || isNaN(Number(this.state.adjustServiceTotal))  ) {
            this.setState({ error: true });
         return;
         }

         params = {
          type: 'gha_adjust',
          params: {
            reason: this.state.adjustServiceReason,
            manual_cost_usd: this.state.adjustServiceTotal
          },
          additional_info: this.state.additionalInformation
        };

        break;
        case 'comat': 
          params = {
            type: 'comat',
            params: { },
            additional_info: this.state.additionalInformation
          };
        break;
        case 'copa_comat': 
          params = {
            type: 'copa_comat',
            params: { },
            additional_info: this.state.additionalInformation
          };
        break;
        case 'nomination_fee': 
          params = {
            type: 'nomination_fee',
            params: { },
            additional_info: this.state.additionalInformation
          };
        break;
        case 'certified_manifest_charge': 
          if (!this.state.transactionDate) {
            this.setState({ error: true });
            return;
          }
          params = {
            type: 'certified_manifest_charge',
            params: { transaction_date: this.state.transactionDate },
            additional_info: this.state.additionalInformation
          };
        break;

      default:
        
        if (Object.keys(this.state.optionalParams).length === 0) {
          this.setState({ error: true });
          return;
        }

        params = {
          type: this.props.serviceRawName,
          params: { ...this.state.optionalParams },
          additional_info: this.state.additionalInformation
        };
        break;
    };

    allServicesAndParams.push(params);
    let servicesToAdd: CartServiceServerParams[] = [];
    let servicesToUpdate: CartServiceServerParams[] = [];

    allServicesAndParams.forEach((cartServiceServerParams: CartServiceServerParams) => {
      let serviceAdded = findCartItemService(this.props.cartItem, cartServiceServerParams.type, cartServiceServerParams.params.reason);
      if(serviceAdded)
        servicesToUpdate.push(cartServiceServerParams);
      else
        servicesToAdd.push(cartServiceServerParams);
    });
    let breakdownHawbFound = servicesToAdd.find(s => s.type === 'breakdown_hawb') !== undefined;

    let payPerHawbFound = servicesToAdd.find(s => s.type === 'per_hawb' || s.type === 'per_hawb_exclude_import_service') !== undefined || findCartItemService(this.props.cartItem, 'per_hawb');
    if(breakdownHawbFound && !payPerHawbFound) {
      this.props.receiveError({errorCode: '', longDescription: 'Cannot add Breakdown by house bill service without Pay per house bill'});
      return;
    }

    if (servicesToAdd.length > 0) {
      const isReturnCart = !!findCartItemService(this.props.cartItem, 'return_fee');
      this.props.addServiceToCart(this.props.cartItem.code, this.props.cartItem.number, this.props.cartItem.version, servicesToAdd, this.props.isExport, isReturnCart ? 'return' : undefined);
      if (this.props.serviceRawName === 'other') {
        this.setState({
          otherServiceReason: '',
          otherServiceTotal: '',
          additionalInformation: '',
          error: false
        })
      }

      if (this.props.serviceRawName === 'gha_adjust') {
        this.setState({
          adjustServiceReason: '',
          adjustServiceTotal: '',
          additionalInformation: '',
          error: false
        })
      }
    }
    
    if(servicesToUpdate.length > 0) {
      if (this.props.serviceRawName === 'comat' || this.props.serviceRawName === 'copa_comat') {
        return;
      }
      const isReturnCart = !!findCartItemService(this.props.cartItem, 'return_fee');
      this.props.updateServicesToCart(this.props.cartItem.code, this.props.cartItem.number, servicesToUpdate, this.props.isExport, isReturnCart ? 'return' : undefined);

    }
    
    this.props.changeIsDeleteStatus(false);
  }

  render() {
    
    const additionalServiceComponent: JSX.Element | null = this.renderAdditionalServiceComponent(this.props.serviceRawName);

    return (
      <Fragment>
        <div className={ additionalServiceWrapperContainerStyles.serviceWrapper } >
          { additionalServiceComponent }
        </div>
        <div className={ additionalServiceWrapperContainerStyles.updateBtnWrapper } >
          <Button color="primary" variant="contained" onClick={ this.handleAddServiceToCart } disabled={ !this.props.allowedService && !this.props.isServiceInCart }>Update</Button>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    additionalServiceTariff: state.additionalService,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    addServiceToCart: (awbCode: string, awbNumber: string, version: number, params: Array<CartServiceServerParams>, isExport?: boolean, type?: string) => dispatch(addServiceToCart(awbCode, awbNumber, version, params, isExport, type)),
    updateServicesToCart: (awbCode: string, awbNumber: string, params: Array<CartServiceServerParams>, isExport?: boolean, type?: string) => dispatch(updateServicesToCart(awbCode, awbNumber, params, isExport, type))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalServiceWrapperContainer);